import { HTMLAttributes } from 'react';

import { cn } from './cn';

/** shadcn/ui empty: centred empty, error and "nothing selected" states. */
export const Empty = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => (
  <div
    data-slot="empty"
    className={cn(
      'flex min-w-0 flex-1 flex-col items-center justify-center gap-4 p-6 text-center text-balance md:p-12',
      className,
    )}
    {...props}
  />
);

export const EmptyHeader = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => (
  <div data-slot="empty-header" className={cn('flex max-w-sm flex-col items-center gap-2', className)} {...props} />
);

export const EmptyMedia = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => (
  <div
    data-slot="empty-icon"
    className={cn(
      'mb-1 flex size-10 shrink-0 items-center justify-center rounded-auditor-lg bg-brand-subtle text-brand',
      className,
    )}
    {...props}
  />
);

export const EmptyTitle = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => (
  <div data-slot="empty-title" className={cn('text-base font-semibold text-ink', className)} {...props} />
);

export const EmptyDescription = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => (
  <div data-slot="empty-description" className={cn('text-sm text-ink-muted', className)} {...props} />
);

export const EmptyContent = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => (
  <div
    data-slot="empty-content"
    className={cn('flex w-full max-w-sm min-w-0 flex-col items-center gap-3 text-sm', className)}
    {...props}
  />
);
